import React from 'react';
import VerificationCodeRouter from './VerificationCodeRouter';

export default function VerificationCodePage() {
  return <VerificationCodeRouter />;
}
